<template>
    <v-flex xs12>
        <v-container>
            <v-data-table :headers="titulos" :items="dados" hide-actions :search="search" no-data-text="Sem resultados">
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center" v-for="(t,i) in titulos" :key="i">
                        <span v-if="t.value!='acoes'">{{ props.item[t.value] }}</span>
                    </td>
                </template>
            </v-data-table>
        </v-container>
    </v-flex>
</template>


<script>
    export default {
        name: "CTable",
        props: ["icon", "descricao","titulos", "dados"],
        data(){
            return{
                search: '',
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/CTable.vue